<template>
  <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onClickRefresh">
    <template slot="toolbar">
    </template>

    <template slot="table-filter">
      <b-form style="width: 100%" @submit.prevent="onSubmit">
        <div class="sa-form-section sa-search-box">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Bar Code</label>
                <b-form-input v-model="filtro.cf"></b-form-input>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Agenda</label>
                <b-form-select v-model="filtro.idAgenda" @change="onChangeAgenda" :value="null"
                  value-field="codiceStruttura" text-field="denominazione">
                  <template #first>
                    <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                  </template>
                  <template>
                    <b-form-select-option v-for="agenda of agendaOptions" :key="agenda.id" :value="agenda.id">
                      {{ agenda.titolo }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Prestazione</label>
                <b-form-select v-model="filtro.prestazione" :value="null" value-field="codiceStruttura"
                  text-field="denominazione">
                  <template #first>
                    <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                  </template>
                  <template>
                    <b-form-select-option v-for="agenda of prestazioniOptions" :key="agenda.codicePrestazione"
                      :value="agenda.codicePrestazione">
                      {{ agenda.descrizionePrestazione }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Dal</label>
                <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Dal"
                  v-model="filtro.dataRiferimentoDal" type="date"></date-picker>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Al</label>
                <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Al"
                  v-model="filtro.dataRiferimentoAl" type="date"></date-picker>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Stato</label>
                <b-form-select v-model="filtro.stato" :value="null" value-field="codiceStruttura"
                  text-field="denominazione">
                  <template #first>
                    <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                  </template>
                  <template>
                    <b-form-select-option :value="'PRENOTATO'">
                      PRENOTATO
                    </b-form-select-option>
                    <b-form-select-option :value="'ESEGUITO'">
                      ESEGUITO
                    </b-form-select-option>
                    <b-form-select-option :value="'NON ESEGUITO'">
                      NON ESEGUITO
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
              class="d-flex justify-content-end align-items-center p-3">
              <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-primary" @click="onSubmit">
                <i class="fas fa-search"></i>
                Ricerca
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-form>
    </template>
    <template slot="table-body">
      <AccettazionePrestazioniListComponent ref="cmpAccettazionePrestazioniListComponent" />
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import AccettazionePrestazioniListComponent from "../components/AccettazionePrestazioniListComponent.vue"
import DatePicker from "vue2-datepicker";
import toast from "../../../../template/layout/utility/sa-toast.js";


// import DatePicker from "vue2-datepicker";
//import { jsontest } from "../components/jsontest.js";

export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  //DatePicker,
  components: {
    SaPageLayout, AccettazionePrestazioniListComponent, DatePicker
  },
  mixins: { UtilityMixin },
  data() {
    return {
      pathResourcePresidi: "/utentipresidi",
      rows: 0,
      perPage: 20,
      user: {},
      isRicercaComponent: false,
      presidiOptions: [],
      prestazioniOptions: [],
      page: 1,
      presidio: null,
      agendaOptions: [],
      dataRiferimento: new Date().getTime(),
      filtro: {
        idAgenda: null,
        prestazione: null,
        stato: null,
        barcode: "",
        dataRiferimentoDal: new Date().getTime(),
        dataRiferimentoAl: new Date().getTime(),
      },
      listKey: 0,
      showModalLoading: false,
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        let presidio = JSON.parse(tmpPresidio);
        this.presidio = presidio;
        this.filtro.idPresidio = presidio.idPresidio;
      }
      this.loadUserData();
      this.loadAgende();
      const unaSettimanaInMs = 7 * 24 * 60 * 60 * 1000;
      this.filtro.dataRiferimentoAl = this.filtro.dataRiferimentoDal + unaSettimanaInMs;
    },
    onClickRefresh() {
      this.init();
    },
    onSubmit() {
      this.$refs.cmpAccettazionePrestazioniListComponent.init(this.filtro, this.dataRiferimento);
    },
    loadUserData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/users/profile";
      axios
        .get(link)
        .then((response) => {
          me.utente = response.data.data;
          me.user = me.utente;
          me.user.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
          me.user.ruolo = me.utente.profilo;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadAgende() {
      if (!this.filtro.idPresidio) {
        toast.warning("Selezionare Presidio");
        return;
      }
      let link = process.env.VUE_APP_PATH_API + "/agende";
      axios
        .get(link, { params: this.filtro })
        .then((response) => {
          this.agendaOptions = response.data.data;

        })
        .catch((e) => {
          console.log(e);
        });

    },

    onChangeAgenda(v) {
      console.log(v);
      let link = process.env.VUE_APP_PATH_API + "/agendaprestazioni?idAgenda=" + v;
      this.openShowModalLoading();
      axios.get(link).then((response) => {
        this.prestazioniOptions = response.data.data;
        this.closeShowModalLoading();
      });

    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onBeforeSaved(item) {
      console.log(item);

      //devido se fare redirect su pagina scheda paziente o ricarice la paginaa
    },

    setFiltroSessionStorage(filtro) {
      let me = this;
      me.filtro.page = me.page;
      me.filtro.forPage = me.perPage;
      sessionStorage.setItem("filtroPageAppuntamenti", JSON.stringify(filtro));
    },

  },
};
</script>

<style scoped></style>
